import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
@Component({
  selector: 'app-onoff',
  imports: [FormsModule],
  templateUrl: './onoff.html',
  styles: ``,
})
export class Onoff {
  @Input() label: string = '';
  @Input() value: boolean = false;
}
